// App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import Home from "./Page/Home";
import Aboutus from "./Page/Aboutus";
import Destinations from "./Page/Destinations";
import TravelThemes from "./Page/TravelThemes";
import Heritage from "./Page/Heritage";
import Beaches from "./Page/Beaches";
import Mountain from "./Page/Mountain";
import Riverside from "./Page/Riverside";
import Wildlife from "./Page/Wildlife";
import Hotels from "./Component/Hotels";
import MultipleServices from "./Component/MultipleServices";
import OurPackage from "./Component/OurPackage";
import Contact from "./Component/Contact";
import Register from "./Component/Register";
import Login from "./Component/Login";
import ScrollToTop from "./Component/ScrollToTop";
// Import luxury theme
import "./Vender/css/LuxuryTheme.css";
// Wrapper to extract `path` param
import { useParams } from "react-router-dom";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/destinations/:path" element={<DestinationsWrapper />} />
        <Route path="/travelthemes" element={<TravelThemes />} />
        <Route path="/services" element={<MultipleServices />} />
        <Route path="/heritage" element={<Heritage />} />
        <Route path="/beaches" element={<Beaches />} />
        <Route path="/mountain" element={<Mountain />} />
        <Route path="/riverside" element={<Riverside />} />
        <Route path="/wildlife" element={<Wildlife />} />
        <Route path="/hotel" element={<Hotels />} />
        <Route path="/ourproduct" element={<OurPackage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      <Footer />
    </Router>
  );
}

function DestinationsWrapper() {
  const { path } = useParams();
  return <Destinations data={path} />;
}

export default App;
